import {Box, Button, Center, Flex, Image, Text} from '@chakra-ui/react'
import CheckIcon from '@assets/svgs/exam/checked.svg'
import LightingIcon from '@assets/svgs/exam/lighting.svg'
import StarIcon from '@assets/svgs/exam/star.svg'
import CategoryIcon from '@assets/svgs/exam/category.svg'
import {useNavigate} from 'react-router-dom'
import {CommonColors} from '@utils/CommonStyles'
import {PATH} from '@utils/Const'

const fourItem = [
  {
    title: 'Đánh giá chuẩn chuyên gia',
    icon: CheckIcon,
    bg: 'rgba(0, 180, 28, 0.10)',
  },
  {
    title: 'Ứng dụng công nghệ AI hàng đầu',
    icon: LightingIcon,
    bg: 'rgba(236, 101, 44, 0.10)',
  },
  {
    title: 'Trải nghiệm học cá nhân hoá',
    icon: StarIcon,
    bg: '#FFF5CC',
  },
  {
    title: 'Lựa chọn đa dạng cách luyện thi',
    icon: CategoryIcon,
    bg: '#E5F2FF',
  },
]

const Header = ({handleGoToExamRoom}: any) => {
  const navigate = useNavigate()

  return (
    <Box bg={CommonColors.white} p={{base: '16px', md: '32px'}}>
      <Flex
        flexDirection={{base: 'column', md: 'row'}}
        maxW={'1400px'}
        mx={'auto'}>
        <Flex
          w={{base: '100%', md: '60%'}}
          flexDirection={'column'}
          justifyContent={'space-between'}>
          <Box>
            <Text fontSize={{base: '24px', lg: '30px'}} fontWeight={'600'}>
              Phòng luyện IELTS Speaking
            </Text>
            <Text
              mt={'16px'}
              fontSize={{base: '14px', lg: '16px'}}
              fontWeight={'400'}
              color={'#7C7C7C'}>
              Mang đến trải nghiệm luyện tập Speaking như trong kỳ thi thật
            </Text>
          </Box>
          <Flex gap={'16px'} mt={{base: '16px', md: '0'}}>
            <Button
              bg={CommonColors.primary}
              color={'white'}
              onClick={handleGoToExamRoom}
              fontSize={{base: '12px', md: '16px'}}
              _hover={{bg: CommonColors.primary}}>
              Luyện thi Part 1: Hometown
            </Button>
            <Button
              variant={'outline'}
              color={'#59BAFF'}
              borderColor={'#59BAFF'}
              onClick={() => {
                navigate(PATH.EXAM_HISTORY)
              }}
              fontSize={{base: '12px', md: '16px'}}>
              Bài nói của bạn
            </Button>
          </Flex>
        </Flex>
        <Flex
          flex={1}
          flexDirection={'column'}
          gap={'16px'}
          mt={{base: '16px', md: '0'}}>
          {fourItem.map((item, index) => (
            <Flex key={index} alignItems={'center'} gap={'16px'}>
              <Center w={'40px'} h={'40px'} borderRadius={'50%'} bg={item.bg}>
                <Image src={item.icon} w={'20px'} h={'20px'} />
              </Center>
              <Text>{item.title}</Text>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Box>
  )
}

export default Header
